export const setSessionData = async (key: string, value: string) => {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
    }
  };
  
  export const getSessionData = (key: string): string | null => {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {

      return null;
    }
  };

  export const removeSessionData = async (key: string) => {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      // error removing value
      console.error("Error removing data:", e);
    }
  };
  